import { __rest } from "tslib";
import * as React from 'react';
import { TextInput } from '@patternfly/react-core';
export class TableTextInput extends React.Component {
    constructor() {
        super(...arguments);
        this.handleBlur = (event) => {
            this.props.onBlur(event.currentTarget.value, event);
        };
    }
    render() {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const _a = this.props, { defaultValue, onBlur, autoFocus, value, onChange } = _a, textInputProps = __rest(_a, ["defaultValue", "onBlur", "autoFocus", "value", "onChange"]);
        return (React.createElement(TextInput, Object.assign({}, textInputProps, { value: undefined, defaultValue: defaultValue, onBlur: this.handleBlur, autoFocus: autoFocus })));
    }
}
TableTextInput.displayName = 'TableTextInput';
TableTextInput.defaultProps = {
    autoFocus: false
};
//# sourceMappingURL=TableTextInput.js.map